import Checkbox from "../../../components/Checkbox";
import { partnerStatusReason, seasonalStatusLabel } from "../../../Util/statusReason";
import React, { useCallback, useEffect, useState } from "react"
import { PATH_PROPERTY } from "../../../Util/constants"
import { useHistory } from "react-router-dom"
import swal from "sweetalert"
import canOff from "../../../assets/property/can-off.svg";
import canOn from "../../../assets/property/can-on.svg";
import starOff from "../../../assets/property/star-off.svg";
import regenerateOn from "../../../assets/property/star-on.svg";
import regenerateOff from "../../../assets/property/star-off.svg";
import starOn from "../../../assets/property/star-on.svg";
import picLeft from "../../../assets/property/pic-left-dark.png";
import picLeftOn from "../../../assets/property/pic-left-on-dark.png";
import picRight from "../../../assets/property/pic-right-dark.png";
import picRightOn from "../../../assets/property/pic-right-on-dark.png";
import switchOff from "../../../assets/property/switch.svg";
import switchOn from "../../../assets/property/switch-on.svg";
import Button from "../../../components/Buttons/Button/Button"
import ImageWithHover from "../../../components/ImageWithHover";
import VTChannelIcon from "../../../assets/channels/icons/VTChannel.svg"
import VTChannelIconOn from "../../../assets/channels/icons/VTChannel-on.svg"
import VTChannelIconOnBlue from "../../../assets/channels/icons/VTChannel-on-blue.svg"
import VTChannelLabel from "../../../assets/channels/icons/label-VTChannel.svg"

import SHChannelIcon from "../../../assets/channels/icons/SHChannel.svg"
import SHChannelIconOn from "../../../assets/channels/icons/SHChannel-on.svg"
import SHChannelIconOnBlue from "../../../assets/channels/icons/SHChannel-on-blue.svg"
import SHChannelLabel from "../../../assets/channels/icons/label-SHChannel.svg"

import TLChannelIcon from "../../../assets/channels/icons/TLChannel.svg"
import TLChannelIconOn from "../../../assets/channels/icons/TLChannel-on.svg"
import TLChannelIconOnBlue from "../../../assets/channels/icons/TLChannel-on-blue.svg"
import TLChannelLabel from "../../../assets/channels/icons/label-TLChannel.svg"

import eventsIcon from "../../../assets/special-collection/icons/events.svg"
import eventsIconOn from "../../../assets/special-collection/icons/events-on.svg"
import eventsIconOnBlue from "../../../assets/special-collection/icons/events-on-blue.svg"
import eventsLabel from "../../../assets/special-collection/icons/label-events.svg"

import dogsIcon from "../../../assets/special-collection/icons/dogs.svg"
import dogsIconOn from "../../../assets/special-collection/icons/dogs-on.svg"
import dogsIconOnBlue from "../../../assets/special-collection/icons/dogs-on-blue.svg"
import dogsLabel from "../../../assets/special-collection/icons/label-pets.svg"

import greenIcon from "../../../assets/special-collection/icons/green.svg"
import greenIconOn from "../../../assets/special-collection/icons/green-on.svg"
import greenIconOnBlue from "../../../assets/special-collection/icons/green-on-blue.svg"
import greenLabel from "../../../assets/special-collection/icons/label-sustainable.svg"

import familiesIcon from "../../../assets/special-collection/icons/kids.svg"
import familiesIconOn from "../../../assets/special-collection/icons/kids-on.svg"
import familiesIconOnBlue from "../../../assets/special-collection/icons/kids-on-blue.svg"
import familiesLabel from "../../../assets/special-collection/icons/label-families.svg"
import bathIcon from "../../../assets/property/baths.png";
import bedsIcon from "../../../assets/property/beds.png";
import peopleIcon from "../../../assets/property/people.png";

import CollectionIcon from "../../../components/CollectionIcon"
import RegionsDropDown from "../../../components/RegionsDropDown"
import { ShubAuth } from "../../../core";
import "./ListingRow.scss"
import { getStorageValue } from "../../../Util/general";

import axios from "axios";
import constants from "../../../Util/constants";

//Custom Title & Desc
import Popup from "../../../components/Popup/index.js";
import InputField from "../../../components/InputField";
import TextAreaField from "../../../components/TextAreaField/index";
import { isOnDemandListing } from "../../../Util/onDemand";
import { OnDemandBadge, PriceOnRequest } from "../../../components/OnDemand";

const Listingrow = (props) => {

  //Custom Title & Desc
  const { property, fullCalendar, id, agent, agency, partner, xdata, updateXdata, listingAddressFull, listingAddressZipExists, QOD, customTitle, customDesc, basePriceUSDConverted, weekendBasePriceUSDConverted } = props

  const agentData = JSON.parse( localStorage.getItem('agent') );
const exchangeRatesData = JSON.parse( localStorage.getItem("exchangeRatesData") );

  //console.log('property:::', property)

  const [chk, setChk] = useState([])
  const [tags, setTags] = useState(xdata?.tags)
  const [region, setNewRegion] = useState(xdata?.region)
  const [subRegion, setNewSubRegion] = useState(xdata?.subRegion)
  const [picIndex, setPicIndex] = useState(0);
  const history = useHistory()
  const [title, setTitle] = useState(xdata.title || property.title)

  
//NEW
//On all listings pages of VT Extranet, need individual approve button for all properties for easy approving process - https://app.asana.com/1/1200178813358971/project/1208597468828454/task/1212628557835461
const [currentListingStatus, setCurrentListingStatus] = useState(xdata.status)
const [currentListingStatusUpdatedBy, setCurrentListingStatusUpdatedBy] = useState(xdata.statusUpdatedBy)
const [currentListingRegion, setcurrentListingRegion] = useState(xdata.region)


let idValue = '';
if(xdata.region === 'unmapped' || xdata.region==='') {
  idValue = `${id}_unmapped`
} else {
  idValue = id
}
const [checkBoxIdValue, setCheckBoxIdValue] = useState(idValue);

  const summary =
    property?.publicDescription?.summary ||
    property?.publicDescription?.space
  const [desc, setDesc] = useState(xdata.desc || summary)
  const [blockChannels, setblockChannels] = useState(!xdata.newListings && partner?.accountId !== '64072805d57d670040d5fab6')
  const partnerLogin = getStorageValue('partnerLogin')
const token2 = ShubAuth;

const userRequest = axios.create({
    headers: {
        Authorization: `Bearer ${token2}`
    }
});
  


//Custom Title & Desc - START
const [customTitleDescListingId, setCustomTitleDescListingId] = useState(null);
const [customTitleText, setCustomTitleText] = useState(customTitle || '');
const [customDescText, setCustomDescText] = useState(customDesc || '');
const setCustomTitleDescToDefaults = () => {
    setCustomTitleDescListingId(null);
    setCustomTitleText('');
    setCustomDescText('');
    document.body.style.overflow = "auto";
}

const showCustomTitleDescForListingId = async(listingId) => {
  let postData = {id:listingId};
  const res = await userRequest.post(constants.SHUB_URL+'/local/get-custom-title-description', postData);  
  const response = res.data 
  setCustomTitleText( response.data.customTitle || '' );
  setCustomDescText( response.data.customDesc || '' );

  setCustomTitleDescListingId(listingId);    
}
const saveCustomTitleDescription = async() => {
  let postData = {id:customTitleDescListingId, customTitle:customTitleText, customDesc:customDescText};

  const res = await userRequest.post(constants.SHUB_URL+'/local/save-custom-title-description', postData );  
  console.log('saveCustomTitleDescription response:', res.data)

  const response = res.data

  if(response.success===true) {
          swal({
          show: true,
          icon: 'success',
          title: response.message,
          //text: `Text`
          })    

    setCustomTitleDescListingId(null);
    document.body.style.overflow = "auto";
  } else if(response.success===false) {
          swal({
          show: true,
          icon: 'error',
          title: response.message,
          //text: `Text`
          }) 
          
    setCustomTitleDescListingId(null);
    document.body.style.overflow = "auto";
  }
}
//Custom Title & Desc - END


//By Jaison 2025-04-22 - START  
/*
  const [listingIdsToUpdate, setListingIdsToUpdate] = useState([]);
  const handle_listing_ids_to_update = (event) => {
      //alert(event.target.value);
      //alert(event.target.checked);
      if(event.target.checked===true) {
        setListingIdsToUpdate([...listingIdsToUpdate, event.target.value])
      } else if(event.target.checked===false) {
        setListingIdsToUpdate(listingIdsToUpdate.filter(item => item !== event.target.value));
      }
  }
  */
  const agentLoggedIn = JSON.parse( localStorage.getItem('agent') );
  //const allZipcodes = JSON.parse(getStorageValue('allZipcodes') );
  const extranet_vt_logged_in_role = localStorage.getItem('extranet-vt-logged-in-role');

  const [newRegionFromOpenAI, setNewRegionFromOpenAI] =useState('');
  const [newRegionFromOpenAIUpdated, setNewRegionFromOpenAIUpdated] =useState(false);
const [totalUnmapped, setTotalUnmapped] = useState('');

const [unmappedLabel, setUnmappedLabel] = useState('unmapped');

  async function regionLookUpOpenAI(country, zipcode) {

    setNewRegionFromOpenAI('')

    const country_belongs_to = country;
    const zipcode_to_search = zipcode;
  
    const res = await userRequest.post(constants.SHUB_URL+'/local/get-touristic-destination-open-ai', {country:country_belongs_to, zipcode:zipcode_to_search} );

    const response = res.data
console.log('NEW REGION:::', response)    

      if(response.success===true && response.destination !== '') {
        console.log('NEW REGION:::', response.destination);
        setNewRegionFromOpenAI(response.destination);

        setTotalUnmapped(response.totalUnmapped);
        setUnmappedLabel(`unmapped (${response.totalUnmapped})`);

          swal({
          show: true,
          icon: 'success',
          title: response.message,
          //text: `Text`
          })
                
          //currentListingRegion(response.destination)

      }
      else if(response.success===true && response.destination === '') {
          swal({
          show: true,
          icon: 'success',
          title: 'AI returned empty region',
          //text: `Text`
          })
      }
      
      else if(response.success===false) {
          swal({
          show: true,
          icon: 'error',
          title: response.message,
          //text: `Text`
          })         
      }    

  }


  
  async function saveNewRegionFromOpenAI(country, zipcode, listingId='') {

    if(newRegionFromOpenAI === '' ) {
        alert('Region is empty');
        return false;
    }

    if(country === '' ) {
        alert('Country is empty');
        return false;
    }  
    
    if(zipcode === '' ) {
        alert('zipcode is empty');
        return false;
    }     

   //alert('country: '+country+', zipcode:' + zipcode + ', listingId:'+ listingId +',  newRegionFromOpenAI:'+newRegionFromOpenAI)
   //console.log('country: '+country+', zipcode:' + zipcode + ', listingId:'+ listingId +',  newRegionFromOpenAI:'+newRegionFromOpenAI)

   let unmapped_properties_mapping_region_data = {country:country, zipcode:zipcode, listingId:listingId, region:newRegionFromOpenAI }

   let confirmMessage = ''
   if(listingId !== '') {
    confirmMessage = 'Are you sure to update the region of the unmapped listing "'+listingId+'" with "'+newRegionFromOpenAI+'" (country='+country+', zipcode='+zipcode+') ?'
   }
   else { //Update all unmapped under the country, selected and zipcode
    confirmMessage = 'Are you sure to update the region of ALL unmapped listings with "'+newRegionFromOpenAI+'" (country='+country+', zipcode='+zipcode+') ?'
   }


   if( window.confirm(confirmMessage) ) {
    // unmapped_properties_mapping_region_data to new api on shub-vthub and update
    const ShubResponse = await userRequest.post(constants.SHUB_URL+'/local/listings/update-unmapped-region-single-or-all-properties-under-country-zipcode-ai', unmapped_properties_mapping_region_data);

    console.log('ShubResponse:::', ShubResponse)

    if(ShubResponse.data.success===true) {
          swal({
          show: true,
          icon: 'success',
          title: ShubResponse.data.message,
          //text: `Text`
          })

          //window.location.reload();
          setcurrentListingRegion(newRegionFromOpenAI)
          setNewRegionFromOpenAIUpdated(true);

          setCheckBoxIdValue(id);
    }
    else if(ShubResponse.data.success===false) {
          swal({
          show: true,
          icon: 'error',
          title: ShubResponse.data.message,
          //text: `Text`
          })
    }


   }

  }
//By Jaison 2025-04-22 - STOP   

  // The title / description rewrite runs on the hub (POST /local/ai-rewrite,
  // 2026-10-23): the browser no longer holds an OpenAI key.
  async function aiRewrite(input, wordCount, exclude, kind) {
    const res = await userRequest.post(constants.SHUB_URL + '/local/ai-rewrite', { text: input || '', words: wordCount, exclude, kind })
    return res?.data?.success ? res.data.text : ''
  }

  async function AITitle(input, wordCount, exclude) {
    try {
      const text = await aiRewrite(input, wordCount, exclude, 'title')
      if (!text) return
      setTitle(text)
      xdata.title = text
      updateXdata(id, xdata)
      return text
    }
    catch {

    }

  }

  async function AIDesc(input, wordCount, exclude) {
    try {
      const text = await aiRewrite(input, wordCount, exclude, 'description')
      if (!text) return
      setDesc(text)
      xdata.desc = text
      updateXdata(id, xdata)
      return text
    }
    catch {

    }

  }

  const updateData = () => {
    console.log('NEW REGION:', region, subRegion)
    xdata.tags = tags
    xdata.agent = agent?.firstName + ' ' + agent?.lastName
    //xdata.region = region
    //xdata.subRegion = subRegion
    xdata.status = xdata.channel ? (xdata.channel.length > 0) ? "Approved" : xdata?.newListing ? "Pending" : "Declined" : "Pending"
    xdata.agent = agent?.firstName + ' ' + agent?.lastName
    localStorage.setItem("xdata", JSON.stringify(xdata))
    // console.log('updating Xdata: id',id,'xdata:',xdata)
    updateXdata(id, xdata)
  }



  const setAITitle = () => {
    //console.log('xdata:', xdata)
    try {
      AITitle(property?.title, 8, xdata.pmName + ' ' + xdata.nickname)
      AIDesc(summary, 100, xdata.pmName + ' ' + xdata.nickname)
    }
    catch (error) {
      console.error('Caught an error:', error);
    }


    //     console.log('exchanged title:', property._id, property.title, xdata.title)
    // } catch (error) {
    //     console.error('Caught an error:', error);
    // } finally {
    //     console.log('Cleanup actions.');
    // }

    //  console.log('exchanged title:', property._id, property.title, xdata.title)

  }


  const setNextPic = () => {
    setPicIndex((picIndex + 1 >= picLength) ?
      0 : picIndex + 1)
  };

  const setPrevPic = () => {
    setPicIndex(picIndex === 0 ? picLength - 1 : picIndex - 1);
  };

  const removePic = () => {

    // take data.pictures, copy it to xdata.pictures, then slicing the current pic.
    if (!isNullOrEmptyArray(xdata.pictures) && picLength != null && picLength > 1) {
      xdata?.pictures.splice(picIndex, 1)
      console.log('xdata pics', xdata.pictures)
      updateData()
    } else {
      xdata.pictures = property?.pictures
      xdata.pictures.splice(picIndex, 1)
      console.log('set the xdata.pictures to:', xdata.pictures)
      updateData()
    }
    pic = xdata.pictures[picIndex % xdata.pictures?.length].original
    picPosition = picIndex % property.pictures?.length;
    picLength = xdata?.pictures?.length
    console.log(' removed pic:', picIndex, ' from prop:', property._id, 'xdata pics:', xdata.pictures)
    setPrevPic()
  };
  function swap(arr, from, to) {
    arr.splice(from, 1, arr.splice(to, 1, arr[from])[0]);
  }
  const mainPic = () => {

    // make selected pic the first=main one!
    if (!isNullOrEmptyArray(xdata.pictures) && picLength != null && picLength > 1) {
      swap(xdata?.pictures, 0, picIndex);
      console.log('xdata pics', xdata.pictures)
      updateData()
    } else {
      xdata.pictures = property?.pictures
      swap(xdata?.pictures, 0, picIndex);
      console.log('set the xdata.pictures to:', xdata.pictures)
      updateData()
    }
    setPicIndex(0);
    pic = xdata.pictures[0 % xdata.pictures?.length].original
    picPosition = 0 % xdata.pictures?.length;
    picLength = xdata?.pictures?.length
    console.log(' main pic from:', picIndex, '  prop:', property._id, 'xdata pics:', xdata.pictures)
  };

  const isNullOrEmptyArray = (arr) => {
    return arr == null || arr.length === 0;
  };

  const toggleCollection = (collection) => {
    const collectionExist = tags.includes(collection)
    if (collectionExist) {
      setTags(tags.filter((f) => f !== collection)) // remove from xdata channel list
    } else {
      setTags([...tags, collection]) // add to xdata channel list
    }
    //console.log('updating Xdata: id',id,'xdata:',xdata)
    updateData()
  }

  const selectedRegion = (newRegion) => {
    console.log("changing region to:", newRegion)
    setNewRegion(newRegion)
    xdata.region = newRegion
    //updateData()
  }

  const selectedSubRegion = (newSubRegion) => {
    console.log("changing subregion for:", newSubRegion)
    setNewSubRegion(newSubRegion)
    updateData()
  }

  const renderSpecialCollections = () => {
    return (
      /* 	<div>
              <img src={specialEvents} className="img-fluid" style={{ marginRight: '5px', width: '25px' }} />
              <img src={specialFamilies} className="img-fluid" style={{ marginRight: '5px', width: '25px' }} />
              <img src={greenIcon} className="img-fluid" style={{ marginRight: '5px', width: '25px' }} />
              <img src={dogsIcon} className="img-fluid" style={{ marginRight: '5px', width: '25px' }} />
          </div> */
      <div className="search-main-selection-icons"
        style={{
          paddingTop: '5px',
          display: 'grid',
          gridTemplateColumns: '60px 60px 60px 60px',
          justifyItems: 'center',
        }}>
        <CollectionIcon
          readOnly={partnerLogin}
          path={eventsIcon}
          pathOver={eventsIconOn}
          pathOver2={eventsIconOnBlue}
          selected={tags?.indexOf("eventCollection") > -1}
          label={eventsLabel}
          onClick={() => toggleCollection("eventCollection")}
        />
        <CollectionIcon
          readOnly={partnerLogin}
          path={familiesIcon}
          pathOver={familiesIconOn}
          pathOver2={familiesIconOnBlue}
          selected={
            tags?.indexOf("familyCollection") > -1
          }
          label={familiesLabel}
          onClick={() => toggleCollection("familyCollection")}
        />
        <CollectionIcon
          readOnly={partnerLogin}
          path={dogsIcon}
          pathOver={dogsIconOn}
          pathOver2={dogsIconOnBlue}
          selected={tags?.indexOf("petsCollection") > -1}
          label={dogsLabel}
          onClick={() => toggleCollection("petsCollection")}
        />
        <CollectionIcon
          readOnly={partnerLogin}
          path={greenIcon}
          pathOver={greenIconOn}
          pathOver2={greenIconOnBlue}
          selected={
            tags?.indexOf("ecoCollection") > -1
          }
          label={greenLabel}
          onClick={() => toggleCollection("ecoCollection")}
        />

      </div>
    )
  }
  const toggleChannel = (channel) => {
    //console.log(channels,channel)
    const channelExists = xdata.channel?.includes(channel)
    const block = (!xdata.newListings && partner?.accountId !== '64072805d57d670040d5fab6')
    xdata.newListing = false;
    //setblockChannels(block)
    // console.log('block?',block)
    // if (xdata.status === 'Declined') {
    //   if (block) {
    //      console.log('cannot approve declined props from our side!')
    //      swal({
    //       show: true,
    //       icon: 'error',
    //       title: 'cannot re-approve !',
    //       text: "ask the PM to re-connect the property : guestyId=" + id + " : "+property.title
    //   })
    //   return { error: 'cannot re-approve declined props' }
    //   } else {
    //     console.log('re-activated on SHM!')
    //     xdata.newListing=true
    //     xdata.status = 'Approved'
    //   }
    if (channelExists) {
      xdata.channel = xdata.channel.filter((f) => f !== channel)
      if (xdata.channel.length === 0) { xdata.status = 'Pending' }
      console.log('after removal of channel:', channel, xdata.channel)
    } else {

      xdata.channel = [...xdata.channel, channel]
      xdata.status = 'Approved'
    }
    updateData()
  }


  const handleResetButton = () => {
    // console.log("Reset pressed! resseting xdata:", property)
    // console.log("updated xdata:", xdataPayload)
    // console.log("changing region for:", property.address.region)
    // setNewRegion(property.address.region)
    // xdata.region=property.address.region
    //updateData()
  }

  const editProperty = () => {
    //console.log("selected listing:" + propertyId, property)
    localStorage.setItem("property", JSON.stringify(property)) // saving to local the selected listing
    history.push(PATH_PROPERTY, { property, xdata })
  }

  const renderChannels = () => {

    return (

      <div className="channels-main-selection-icons"
        style={{
          paddingTop: '15px',
          display: 'grid',
          gridTemplateColumns: '40px 40px 40px',
          justifyItems: 'center',
        }}>
        {<CollectionIcon
          //readOnly={blockxdata.channel}
          readOnly={partnerLogin}
          path={VTChannelIcon}
          pathOver={VTChannelIconOn}
          pathOver2={VTChannelIconOnBlue}
          selected={xdata?.channel?.includes('VT')}
          selected2={false}
          label={VTChannelLabel}
          onClick={() => toggleChannel("VT")}
        />}
        {<CollectionIcon
          readOnly={partnerLogin}
          //readOnly={!xdata.newListings}
          path={SHChannelIcon}
          pathOver={SHChannelIconOn}
          pathOver2={SHChannelIconOnBlue}
          selected={xdata?.channel?.includes('SH')}
          selected2={false}
          label={SHChannelLabel}
          onClick={() => toggleChannel("SH")}
        />}
      </div>
    )
  }

  //picture:
  let pic = null;
  let picPosition = 0
  let picLength = 0
  if (!isNullOrEmptyArray(xdata.pictures) && picIndex != null) {
    pic = xdata.pictures[picIndex % xdata.pictures?.length].original
    picPosition = picIndex % xdata.pictures?.length;
    picLength = xdata?.pictures?.length

  } else
    if (!isNullOrEmptyArray(property.pictures) && picIndex != null) {
      pic = property.pictures[picIndex % property.pictures?.length].original
      picPosition = picIndex % property.pictures?.length;
      picLength = property?.pictures?.length
    }


const approveSingleProperty = async(listingId) => {

        const updateListingsData = {'accountId':partner?.accountId,'ids':[listingId], 'status':'Approved', statusUpdatedBy:agentData.firstName}


          const ShubResponse = await userRequest.post(constants.SHUB_URL+'/local/listings/update-multiple-listings-status', updateListingsData);  

            if(ShubResponse.data.success === true) {

                swal({
                    show: true,
                    icon: 'success',
                    title: ShubResponse.data.message,
                    text: ShubResponse.data.message
                });

setCurrentListingStatus('Approved');
setCurrentListingStatusUpdatedBy(agentData.firstName);               
                
                //setUpdateStatusProcess( updateStatusProcess + 1 ); //No efefct inside useEffect. So added the below line to run the function to refresh page
                //getAllListings();
                
            } else {
                swal({
                    show: true,
                    icon: 'error',
                    title: ShubResponse.data.message,
                    text: ShubResponse.data.message
                })                
            }          

}    
    
  //main xdata return here:
  return <>
 
    <td className="px-3 p-3 text-primary cst-cursor">
    {/*(extranet_vt_logged_in_role==='admin' && (xdata.region === 'unmapped' || xdata.region === '') ) && 
      <input type="checkbox" key={id} value={`${id}_unmapped`} name="listing_ids_to_update[]"  />
    */}

    {/*(extranet_vt_logged_in_role==='admin' && xdata.region !== 'unmapped' && xdata.region !== '') && 
      <input type="checkbox" key={id} value={id} name="listing_ids_to_update[]"  />
    */}

    <input type="checkbox" key={id} value={checkBoxIdValue} name="listing_ids_to_update[]"  />

  


{extranet_vt_logged_in_role==='partner' && partner.accountId==='585a39dbe43900100017e9e8' &&      
      <label>{xdata.pmName}</label>
    }
    

      <h4>
      <div className="property-main-picture-container">
        <div className="nickname">
          {property.nickname} <span className="property-type">({property?.propertyType})</span><br></br>

          <a target="_blank" href={`https://login.villatracker.com/property/${property._id}`}>
  <span className="property-id">{property._id != null ? property._id : "-"}</span>
</a>          

        </div>
        <div className="img-number">
          {picIndex ? picIndex + 1 : "Main"}/{picLength} Total
          
          {/*<div className="garbage-can">
            {!partnerLogin && <ImageWithHover
              path={canOff}
              pathOver={canOn}
              className="garabage-icon"
              tooltip={'DELETE THIS PIC'}
              onClick={removePic}
            />}
            </div>*/}

          <div className="garbage-can">
            {!partnerLogin && <ImageWithHover
              path={starOff}
              pathOver={starOn}
              tooltip={'set as Main PIC'}
              className="garabage-icon"
              onClick={mainPic}
            />}
          </div>
        </div>
        <div className="property-main-picture-container">
          <div className="img-slider">
            <ImageWithHover
              path={picLeft}
              pathOver={picLeftOn}
              className="property-page-prev-next-pic"
              style={{ left: "10px" }}
              onClick={setPrevPic}
            />
            <div
              className="property-main-picture"
              onClick={() => editProperty()}
              style={{
                backgroundImage: pic ? `url(${pic})` : "transparent",
                backgroundSize: "cover",
              }}
            />
            <ImageWithHover
              path={picRight}
              pathOver={picRightOn}
              className="property-page-prev-next-pic"
              style={{ right: "10px" }}
              onClick={setNextPic}
            />
          </div>
        </div>

        <div className="text-title">
        <h4>{title}</h4>
        </div>

             
      </div>
    </h4>





      {/*//Custom Title & Desc - START*/}
        {customTitleDescListingId && 
        <Popup onClose={setCustomTitleDescToDefaults}>   

                <div class="row">
                  <div class="col-12">
                    <h1>Listing - Custom Title & Description</h1>
                    </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <label>Listing Id: {customTitleDescListingId}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <InputField
                      label="Custom Title"
                      value={customTitleText}
                      onChange={setCustomTitleText}
                      placeholder={"Enter custom title"}
                      style={{ marginTop: "20px" }}
                    />
                  </div>
                </div> 

                <div class="row">
                  <div class="col-12">
                    <TextAreaField
                      label="Custom Description"
                      value={customDescText}
                      onChange={setCustomDescText}
                      placeholder={"Enter custom description"}
                      style={{ height: "300px", marginTop: "20px" }}
                    ></TextAreaField>                   
                  </div>
                </div> 

<div class="row">
      <div class="col-12">&nbsp;</div>
</div>
<div class="row">
      <div class="col-12">&nbsp;</div>
</div>
<div class="row">
      <div class="col-12">&nbsp;</div>
</div> 
                  
                <div class="row">
                  <div class="col-12">
                      <Button
                        style={{ fontSize: "18px"}}
                        text="Save Custom Title & Description" 
                        onClick={saveCustomTitleDescription}
                      />                    
                    </div>
                  </div>

        </Popup>
        }
        <div className="text-title">
          <hr />
          {/* parity 5.3: admin-only custom title/description editor — gate the entry point. */}
          {(extranet_vt_logged_in_role === 'admin' && !partnerLogin) &&
          <div onClick={ ()=> showCustomTitleDescForListingId(property._id)}>
          Custom Title & Description:
          <svg xmlns="http://www.w3.org/2000/svg"
              width="18" height="18"
              viewBox="0 0 24 24"
              fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 20h9"/>
            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/>
          </svg>
          </div>
          }

        </div>
        {/*//Custom Title & Desc - END*/}



    </td>
     <td  className="px-4 p-6 ">
      {currentListingRegion==='unmapped' ? <span style={{color:'red','font-weight':'bold'}}>{unmappedLabel}</span> : <span>Mapped</span> }

      {currentListingRegion==='unmapped' && extranet_vt_logged_in_role==='admin' &&
      <div>
      {/*<input type="text" value={newRegionFromOpenAI} onChange={ (e)=> setNewRegionFromOpenAI(e.target.value) } />*/}
      <button class="btn btn-primary" onClick={()=>regionLookUpOpenAI(property.address.country, property.address.zipcode)}>Region Lookup</button>

      {newRegionFromOpenAI &&
      <div>
      <button class="btn btn-success" onClick={()=>saveNewRegionFromOpenAI(property.address.country, property.address.zipcode, property._id)}>Update single</button> 

      <button class="btn btn-primary" onClick={()=>saveNewRegionFromOpenAI(property.address.country, property.address.zipcode)}>Update all with the same zipcode</button> 
      </div>
      }
        
      </div>
      }
     </td>
    <td  className="px-4 p-6 ">

      <div className="col-sm-6">
        <label><strong>Country:</strong></label>
         &nbsp;{property.address.country || '-Nil'}
        <br /><br />

        <label><strong>State: </strong></label>
         &nbsp;{property.address.state || '-Nil'}
        <br /><br />

        <label><strong>Region: </strong></label>
         &nbsp; {/*xdata.region || '-Nil'*/}
         {newRegionFromOpenAIUpdated ? newRegionFromOpenAI : xdata?.region || '-Nil'}
        <br /><br />
  
        <label><strong>City: </strong></label>
         &nbsp;{property.address.city || '-Nil'}
        <br /><br />

        <label><strong>Sub Region: </strong></label>
         &nbsp;{xdata.subRegion || '-Nil'}
        <br /><br />

        <label><strong>Zipcode: </strong></label>
         &nbsp;{property.address.zipcode || '-Nil'}
      </div>

    </td>
    <td className="px-4 p-3 ">
      <h4>
        {currentListingStatus}
        
        { (currentListingStatus==='Declined' && (xdata.autodecline===true || xdata.autoDecline===true)) &&
          <h4 style={{ backgroundColor: "red" }}>Auto Declined</h4>
        }

        { (extranet_vt_logged_in_role==='admin' && currentListingStatus==='Declined' &&  xdata.declineReason !== '') &&
          <p><i>({xdata.declineReason})</i></p>
        }

        { (extranet_vt_logged_in_role!=='admin' && partnerStatusReason(currentListingStatus, xdata) !== '') &&
          <p style={{ fontSize: "13px", fontWeight: "normal", color: "#667085" }}>
            <i>{partnerStatusReason(currentListingStatus, xdata)}</i>
          </p>
        }

        {/* Seasonal listing (part-year above the $400 floor): shown in season,
            hidden off-season instead of declined — label for partners+admins. */}
        { seasonalStatusLabel(xdata) !== '' &&
          <p style={{ fontSize: "13px", fontWeight: "normal", color: "#0e7ca8" }}>
            <i>{seasonalStatusLabel(xdata)}</i>
          </p>
        }

        {(extranet_vt_logged_in_role==='admin' && currentListingStatusUpdatedBy != null) &&
          <div><label><i>Status Updated By:</i></label><i>{currentListingStatusUpdatedBy}</i></div>
        }
      </h4>

{/*(currentListingStatus?.toLowerCase() !== 'approved' && currentListingRegion !== 'unmapped') && 
  <Button
    style={{ fontSize: "15px"}}
    text="Approve" 
    onClick={()=>approveSingleProperty(property._id)}
  />
*/}

    </td>
    <td className="px-4 p-3">
      <h4>

        {renderSpecialCollections()}<br></br><br></br>
        {isOnDemandListing({ QOD, tags }) ? (
          <span style={{ display: "inline-flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
            <OnDemandBadge />
            <PriceOnRequest />
          </span>
        ) : (
          <>
            weekdays: {property?.prices?.basePrice} {property?.prices?.currency} {basePriceUSDConverted && <span>({basePriceUSDConverted} USD)</span>}<br></br>
            weekend:  {property?.prices?.weekendBasePrice || property?.prices?.basePrice} {property?.prices?.currency} {weekendBasePriceUSDConverted && <span>({weekendBasePriceUSDConverted} USD)</span>}<br></br>
            {property?.prices?.weeklyPriceFactor < 1 && (
              <>
                week discount: {parseInt(100 - property?.prices?.weeklyPriceFactor * 100)}% <br></br>
              </>
            )}
            {property?.prices?.monthlyPriceFactor < 1 && (
              <>
                month discount: {parseInt(100 - property?.prices?.monthlyPriceFactor * 100)}%
              </>
            )}
          </>
        )}
      </h4>
      <div className="property-box-footer-left">
        <div className="property-box-footer-left-icon">
          <img src={peopleIcon} alt="" />
          {property?.accommodates}
        </div>
        <div className="property-box-footer-left-icon">
          <img src={bedsIcon} alt="" />
          {xdata?.beds}
        </div>
        <div className="property-box-footer-left-icon">
          <img src={bathIcon} alt="" />
          {property?.bathrooms}
        </div>
        <div className="property-box-footer-right-icon">
          {/* <img src={bedsIcon} alt="" /> */}
          {property.bedrooms} bedrooms
        </div>
      </div>
    </td>
    <td className="px-4 p-3 text-decoration">

{listingAddressZipExists===true &&
       <h4 style={{'background-color':'green'}}>
       {property?.address?.full}
     </h4>
}
{listingAddressZipExists===false &&
       <h4 style={{'background-color':'red'}}>
       {property?.address?.full}
     </h4>
}
     
      {/* !partnerLogin && <RegionsDropDown
        selectedRegion={selectedRegion}
        selectedSubRegion={selectedSubRegion}
        propertyId={id}
        property={property}
        xdata={xdata}
      /> */}
    </td>
  </>

}
export default Listingrow
